
import Msg from 'vux/src/components/msg/index.vue'

import { payQuery } from "@/model/javaApi/detail.js";
import UserInfoToast from "@/components/toast/userInfo";
import mixinTxrNewWeb from "@/utils/mixin/mixinTxrNewWeb";

export default {
mixins: [mixinTxrNewWeb],
data() {
return {
title: "操作成功!",
statusFlag: false,
goUrl: ''
};
},
created(){
const {url} = this.$route.query;
this.goUrl = url || ''
},
components: {
Msg,
UserInfoToast,
},
computed: {
orderNo() {
return this.$route.query.orderNo || "";
},
tradeNo() {
return this.$route.query.tradeNo || "";
},
channelCommodityCode() {
return this.$route.query.channelCommodityCode;
},
present() {

return (
this.$route.query.ch == "orderlist" ||
this.$route.query.ch == "orderdetail" ||
this.$route.query.ch == "ordersms"
);
},
},
beforeDestroy() {
window.clearInterval(this.timer);
window.clearInterval(this.timeDelayer);
this.$loading.hide();
this.$alert.hide();
},

mounted() {

this.querySetTX();

this.orderState();
},
methods: {

orderState() {

if (!this.orderNo && !this.tradeNo) {
this.STATISTICS_CONFIG.insur_pay_success_page();
this.statusFlag = true;
this.operatingTX(this.channelCommodityCode);
return false;
}

if (this.CHANNAL_ID == "MWEB") {
this.STATISTICS_CONFIG.insur_resultconfirm_page();
document.title = "支付中";
this.$alert({
msg: "是否支付成功",
cancelText: "否",
confirmText: "是",
closeBtn: false,
onCancel: () => {
this.STATISTICS_CONFIG.insur_resultconfirm_no_click();
this.$router.replace({
path: "/MyInsurance",
query: {

flag: "postdisable",

},
});
return false;
},
onConfirm: () => {
this.STATISTICS_CONFIG.insur_resultconfirm_yes_click();
this.check();
},
});
} else {
this.check();
}
},
check() {
this.$loading.show();

this.timeDelayer = setTimeout(() => {
this.$loading.hide();
this.$router.replace({
path: "/detailPayResult",
query: this.$route.query,
});
}, 10000);

this.timer = setInterval(() => {

payQuery({ orderNo: this.orderNo })
.then((data) => {
if (data) {

if (data.orderStatus == "SUCCESS" || data.orderStatus == "REFUND") {
document.title = "操作成功";
this.statusFlag = true;

window.clearInterval(this.timer);
window.clearTimeout(this.timeDelayer);
this.$loading.hide();
this.STATISTICS_CONFIG.insur_pay_success_page();
setTimeout(() => {
this.operatingTX(this.channelCommodityCode);
}, 1000);





}
}
})
.catch((err) => {
window.clearInterval(this.timer);
window.clearTimeout(this.timeDelayer);
this.$loading.hide();
});
}, 1000);
},
goNext(){
let url = new URL(this.goUrl, window.location.origin);
if (!url.searchParams.has('sy_target')) {
url.searchParams.append('sy_target', 'self');
}
window.location.href = url.toString();
}
},
};
